import { Box, Heading, Flex } from '@chakra-ui/react';
import { TenantsTable } from '../../components/tenants-table/tenants-table.comp';

export function TenantsList() {

    return (
        <Box p={4}>
            <Flex>
                <Heading as={'h1'}>Tenants</Heading>
            </Flex>
            <TenantsTable />
        </Box>
    );
}
